import { memo, useCallback, useState } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button } from '@aimsos/ui';

import TraitCard from './TraitCard.jsx';

import { ChevronDown, ChevronRight } from 'lucide-react';

/**
 * The "N unverified" group under the Traits list (CT-5715): low-confidence or
 * unclear traits, collapsed by default so they never read as facts. Expanding is
 * local state — it is a view preference, not part of the query.
 */
const EMPTY_UNVERIFIED = Object.freeze({ count: 0, items: [] });

const TraitsUnverifiedGroup = memo(function TraitsUnverifiedGroup({
  unverified = EMPTY_UNVERIFIED,
  openTraitId,
  onOpen,
}) {
  const { t } = useTranslation('unified-profiles');
  const [expanded, setExpanded] = useState(false);

  const toggle = useCallback(() => setExpanded((value) => !value), []);

  if (!unverified.count) return null;

  return (
    <section data-testid="traits-unverified" className="flex flex-col gap-3">
      <div>
        <Button
          variant="ghost"
          size="sm"
          leftIcon={expanded ? ChevronDown : ChevronRight}
          aria-expanded={expanded}
          onClick={toggle}
        >
          {t('intelligence.traits.unverifiedGroup', { count: unverified.count })}
        </Button>
      </div>
      {expanded ? (
        <div className="flex flex-col gap-3">
          {unverified.items.map((trait) => (
            <TraitCard
              key={trait.id}
              trait={trait}
              unverified
              selected={trait.id === openTraitId}
              onOpen={onOpen}
            />
          ))}
        </div>
      ) : null}
    </section>
  );
});

export default TraitsUnverifiedGroup;
